import {
  parseAsActiveStatus,
  parseAsString,
  useQueryStates,
} from '@vrplatform/query-params';
import { hasValue } from '@vrplatform/utils';

export const useOwnersTableFilter = () => {
  const [filter, setFilter] = useQueryStates({
    search: parseAsString,
    type: parseAsString,
    status: parseAsActiveStatus.withDefault('active'),
  });

  const isFiltered = Object.values(filter).some(hasValue);

  return {
    filter,
    setFilter,
    isFiltered,
    reset: () => setFilter(null),
  };
};
